import React, { useState } from "react";
import PropTypes from "prop-types";
import "./DynamicInput.css";
import { Globals } from "../../global/Globals";
import { formatCurrency } from "../../util/util";

const DynamicInput = ({
  type,
  label,
  isRequired,
  defaultValue,
  validate,
  inputError,
  className,
  onChange,
  width = "350px",
  height = "70px", // For TextArea height
  maxCount = 1024,
  inputMode ='text',
  pattern,
  inputValue,
  onBlur,
  isEpisode,
  maxLength=100
}) => {
  const [value, setValue] = useState(inputValue || "");
  const multiLang = localStorage.getItem("lang");
  const handleTargetChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/,/g, "");
    const regex = /^\d+(\.\d{0,2})?$/;
    const formattedCurrency=formatCurrency(numericValue)
    if (regex.test(numericValue) && numericValue.length <= 15 && (numericValue !== "0" || numericValue === "")) {
      setValue(formattedCurrency);
      onChange(formattedCurrency);
    } else {
        // If the value doesn't match the regex, truncate it to two decimal places
        if (numericValue !== "0" && numericValue !== "") {
            const truncatedValue = formattedCurrency;//parseFloat(formattedCurrency).toFixed(2);
            if (truncatedValue.length <= 15) {
              setValue(truncatedValue);
              onChange(truncatedValue);
               
            } else {
                // Handle case where truncated value exceeds max length
                const maxLengthValue = truncatedValue.slice(0, 15);
                numericValue !== "0" && setValue(maxLengthValue);
                onChange(maxLengthValue);
                // validateField1('targetBudget', maxLengthValue);
            }
        } else {
            // Allow deletion of characters
            if(numericValue!=="0"){
                setValue(formattedCurrency);
              onChange(formattedCurrency);
            }
            
        }
    }
};
  const handleKeyDown = (event) => {
    // Prevent non-numeric input
    if (event?.key === '-' && type === 'input') {
      event.preventDefault()
    }
  }   
  const handleKeyDownInput = (event) => {
    // allow control keys
    if (
      ["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight"].includes(event.key)
    ) {
      return;
    }

    // allow only one decimal point
    if (event.key === ".") {
      if (event.currentTarget.value.includes(".")) {
        event.preventDefault();
      }
      return;
    }

    // block anything that's not 0–9
    if (event.key < "0" || event.key > "9") {
      event.preventDefault();
    }
  };

  return (
    <div className={`dynamicinput-container`}>
      {type === "textarea" ? (
        <>
          <textarea
            className={`text-area ${className} height-75-px`}
            value={value}
            placeholder={defaultValue}
            onChange={(e) => {
              const inputText = e.target.value;
                setValue(inputText);
                onChange(inputText);
            }}
            onBlur={(e) => {
              const inputText = e.target.value;
                setValue(inputText);
                onBlur(inputText);
            }}
            style={{ 
              width: width, 
              height: "75px !important",
            }}
            required
            maxLength={maxCount}
          />
          <div className="char-counter" style={{display:"flex"}}>
          {((isRequired || isEpisode) &&  inputError) && <p className="invalidCredential" style={{margin:0,display:'flex',alignItems:'flex-start'}}> <img id="login-error" className="icon-style login-error" src={Globals.IMG.ERROR} alt="password error" /><span className={`dynamicinput-${multiLang}`}>{inputError}</span></p>}
          <div style={{flex:1}}>{value.length}/{maxCount}</div>  
          </div>
        </>
      ) : (
        <>
        <input
          type={type === "input" && isRequired ? "text" : "text"} // Set type to number for numeric input
          className={`dynamicinput-input ${className}`}
          value={value}
          placeholder={defaultValue}
          onChange={(e) => {
            if(type!=="input"){
              setValue(e.target.value);
              onChange(e.target.value);
            }else{
              handleTargetChange(e)
            }
          }}
          onBlur={(e) => {
            if(type!=="input"){
              setValue(e.target.value);
              onBlur(e.target.value);
            }else{
              handleTargetChange(e)
            }
          }}
              onKeyDown={(e) => {
                if (type === "input") {
                  handleKeyDownInput(e);
                } else {
                  handleKeyDown(e);
                }
              }}
          style={{
            width: width,
          }}
          maxLength={maxLength}
          required
          min="1"
          inputMode={type === "input" && isRequired ? "text" : inputMode} // Set inputMode to numeric for numeric input
          pattern={type === "input" && isRequired ? "\\d*" : pattern} // Set pattern to allow only digits for numeric input
        />
        {isRequired && inputError && <p className="invalidCredential" style={{margin:0,display:'flex',alignItems:'flex-start'}}> <img id="login-error" className="icon-style login-error" src={Globals.IMG.ERROR} alt="password error" /><span>{inputError}</span></p>}
        </>
      )}
    </div>
  );
};

DynamicInput.propTypes = {
  type: PropTypes.oneOf(["text", "textarea"]).isRequired,
  label: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
  defaultValue: PropTypes.string,
  validate: PropTypes.func,
  inputError: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

DynamicInput.defaultProps = {
  isRequired: false,
  defaultValue: "",
  validate: () => "",
  inputError: "",
  className: "",
  width: "350px",
  height: "70px",
};

export default DynamicInput;
